import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// cc_15: GIF picker over the authed Giphy proxy (key never ships). Trending by default, search on type.
export function GifPicker({ open, onOpenChange, onSend }) {
  const [q, setQ] = useState("");
  const [term, setTerm] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setTerm(q.trim()), 350);
    return () => clearTimeout(t);
  }, [q]);
  const { data, isLoading } = useQuery({
    queryKey: ["gifs", term],
    queryFn: () => (term ? api.gifsSearch(term) : api.gifsTrending()),
    enabled: open,
    staleTime: 60000,
    retry: false,
  });
  const items = data?.items || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-white/10 bg-bloq-s1 text-white sm:max-w-lg" data-testid="gif-picker">
        <DialogHeader>
          <DialogTitle className="font-heading">Send a GIF</DialogTitle>
          <DialogDescription className="text-bloq-muted">Powered by GIPHY</DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-bloq-bg px-3">
          <Search className="h-4 w-4 text-bloq-muted" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search GIPHY…" autoFocus className="h-10 flex-1 bg-transparent text-sm outline-none" data-testid="gif-search-input" />
        </div>
        <div className="grid max-h-[55vh] grid-cols-3 gap-2 overflow-y-auto pr-1" data-testid="gif-grid">
          {isLoading ? (
            <div className="col-span-3 flex justify-center py-10 text-bloq-muted"><Loader2 className="h-5 w-5 animate-spin" /></div>
          ) : items.length === 0 ? (
            <div className="col-span-3 py-10 text-center text-sm text-bloq-muted">No GIFs found</div>
          ) : (
            items.map((g) => (
              <button
                key={g.giphy_id}
                type="button"
                onClick={() => { onSend(g); onOpenChange(false); }}
                className="overflow-hidden rounded-xl border border-white/8 bg-bloq-s2 transition-transform hover:scale-[1.03]"
                title={g.title}
                data-testid={`gif-item-${g.giphy_id}`}
              >
                <img src={g.preview_url || g.url} alt={g.title || "GIF"} loading="lazy" className="h-28 w-full object-cover" />
              </button>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
